import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute, requireAdmin } from '../route';

const RexelMonitoringPage = lazyRouteComponent(
  () => import('./RexelMonitoringPage'),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rexel-monitoring',
  staticData: {
    app: {
      access: {
        adminOnly: true,
      },
    },
  },
  component: RexelMonitoringPage,
  loader: () => ({
    crumb: msg('Rexel Monitor', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireAdmin({ context });
  },
});
